import React from 'react'

function ClearAllFilters({onClick}) {
  return (
    <button className='ps-0 d-flex align-items-center gap-2 bg-transparent border-0' onClick={onClick}>
      <svg id="check" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14">
        <defs>
          <rect id="Background" width="14" height="14" fill="none" />
        </defs>
        <g id="Rectangle" fill="none" stroke="#f06548" strokeMiterlimit="10" strokeWidth="1">
          <rect width="14" height="14" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="13" height="13" rx="3.5" fill="none" />
        </g>
        <g id="download_" data-name="download ">
          <rect id="Background-2" data-name="Background" width="14" height="14" fill="none" />
          <g id="download_2" data-name="download ">
            <path id="Shape" d="M5.5.554,4.946,0,2.75,2.2.554,0,0,.554l2.2,2.2L0,4.946.554,5.5l2.2-2.2,2.2,2.2L5.5,4.946,3.3,2.75,5.5.554Z" transform="translate(4.25 4)" fill="#f06548" />
          </g>
        </g>
      </svg>
      Clear All Filters
    </button>
  )
}

export default ClearAllFilters
